<template>
    <div>

        <markdown-text :text="text"></markdown-text>

        <div class="font-weight-bold text-sm mt-3 mb-1" v-if="hasReferencedSections">Referenced Sections</div>

        <v-chip-group v-model="sectionSelected" column>
            <v-chip
                v-for="(chip, index) in sources"
                :key="index" :value="chip.meta_xmlId"
                :text="displayChipInfo(chip)"
                @click="getSection(chip.meta_xmlId)"
                small
                :color="chip.meta_xmlId === sectionSelected ? 'primary' : 'primaryLight'"
                :class="chip.meta_xmlId === sectionSelected ? 'text--white' : 'primary--text'">
                <span v-html="displayChipInfo(chip)" class="ai-reference-section"></span>
            </v-chip>
        </v-chip-group>
        <div class="text-center pa-2"  v-if="loadingReferenceContent">
            <v-progress-circular
                indeterminate
                color="primary">
            </v-progress-circular>
        </div>
        <default-content-section-controller
            v-else
            class="mt-2"
            highlightType="add-note"
            :registerDialogs="false"
            :content-sections="contentSections"
            :is-notes-section-expanded="true" />
    </div>
</template>

<script>
import MarkdownText from "../../MarkdownText.vue";
import DefaultContentSectionController from "../../content-section/DefaultContentSectionController.vue";
import { ContentSectionApi } from "../../../api/ContentSectionApi";

export default {
    components: {  MarkdownText, DefaultContentSectionController },
    props: {
        // as it appears in "ai_navigator_question_logs" basically
        // response you get from when asking question "live" versus fetching from database - structure differs
        response: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            sectionSelected: null,
            contentSections: [],
            loadingReferenceContent: false
        }
    },
    computed: {
        text() {
            return this.response.text || '';
        },
        sources() {
            return this.response?.sources || [];
        },
        hasReferencedSections() {
            return this.sources.length > 0;
        }
    },
    methods: {
        displayChipInfo(chip) {

            // looks like - IPMC2024P1_Ch06_Sec602.2
            const metaXmlId = chip.meta_xmlId || '';

            let bookShortCode = chip.bookShortCode || '';
            let bookYear = chip.bookYear || '';
            let ordinalNumber = chip.meta_ordinal || '';

            if (!bookShortCode) {
                const match = metaXmlId.match(/^([A-Z]{2,5})\d+/);
                if (match) {
                    bookShortCode = match[1];
                }
            }

            // if ordinal number is empty then extract section number through regex
            if (!ordinalNumber) {
                // matching again something like - IFC2024P1_Pt01_Ch02_Sec202_DefDETECTOR_HEAT
                const match = metaXmlId.match(/Sec([A-Za-z0-9]+)/);
                if (match) {
                    ordinalNumber = match[1];
                }
            }

            return `${bookShortCode} ${bookYear} (${ordinalNumber})`;
        },

        async getSection(xmlId) {
            this.loadingReferenceContent = true;
            try {
                const { data } = await ContentSectionApi.getSectionsContentByXmlIds(xmlId);
                this.contentSections = data.sections ?? [];
            } catch (e) {
                console.error("Failed to fetch content", e);
            } finally {
                this.loadingReferenceContent = false;
            }
        },
    }
}
</script>
